// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__fsKBd","inputWrap":"styles_inputWrap__2jfLa","input":"styles_input__1ylEs"};